export default __webpack_public_path__ + "static/media/steps-area.cb6f88b7.png";